module.exports = __webpack_public_path__ + "static/media/AlbondigaRes.9e287ea3.jpg";